module.exports = __webpack_public_path__ + "assets/img/criancas.32994c0f.jpg";